import React, { useEffect, useState } from "react";
import AppButton from "components/AppButton/AppButton";
import { inject, observer } from "mobx-react";
import TestSMS from "../Modals/TestSMS";
import { message as notification } from "antd";
import AlertModal from "components/Modals/AlertModal";
import clsx from "clsx";
import { optOutMessageSample, replyStopMessageSample } from "constant/messageConstants";
import { isEmpty } from "lodash";
import TestMessage from "../Modals/TestMessage";
import { toJS } from "mobx";

function SendTestSMS(props) {
  const {
    modalStore,
    gatewayStore,
    gatewayMmsStore,
    btnProps = {},
    isMms,
    name = "message",
    label = "Send Test Message",
    size = "large",
    isFirstTime,
    setIsFirstTime,
    values,
    quickMessage = false,
    skip = false,
    saveAndContinue,
    setFieldValue,
    lowBalanceAlert = false,
    showNextButton = true,
    testMessageStore,
    authStore
  } = props;

  const firstNumber = values?.numberList?.[0];

  const firstNumberAsArray = values?.contacts && values?.numberList?.[0] ? values.contacts.map(() => ({ ...values.numberList[0] })) : [];

  const { user } = authStore;
  const [successAlert, setSuccessAlert] = useState(false);
  const [formattedContact, setFormattedContact] = useState(null);

  const createContactObject = (phoneNumber, contactData = {}) => {
    return {
      label: phoneNumber,
      value: phoneNumber,
      contact: phoneNumber,
      contactData
    };
  };

  useEffect(() => {
    const fetchAndFilter = async () => {
      await testMessageStore.fetchRecentNumbers();
      const recentNumbers = toJS(testMessageStore.recentNumbers);

      const filteredContact = recentNumbers.find(contact => contact.phoneNumber === user?.mobile);
      if (filteredContact) {
        const formattedContactData = createContactObject(filteredContact.phoneNumber, filteredContact.contactData);

        setFormattedContact(formattedContactData);
      } else {
        setFormattedContact(null);
      }
    };

    fetchAndFilter();
  }, []);

  const getBalanceData = () => {
    try {
      const totalSMS = localStorage.getItem("balance");
      if (!totalSMS) {
        return { isShowTest: false };
      }

      const parsedSMS = JSON.parse(totalSMS);

      let totalSMSCount = 0;

      if (parsedSMS?.value?.maxPossibleCredits?.sms) {
        totalSMSCount = parseInt(parsedSMS.value.maxPossibleCredits.sms, 10);
      } else if (parsedSMS?.maxPossibleCredits?.sms) {
        totalSMSCount = parseInt(parsedSMS.maxPossibleCredits.sms, 10);
      } else if (parsedSMS?.sms) {
        totalSMSCount = parseInt(parsedSMS.sms, 10);
      }

      const isShowTest = (testMessageStore?.totalMessagesCount || 0) <= totalSMSCount;

      return { isShowTest };
    } catch (error) {
      console.error("Error parsing balance data:", error);
      return { isShowTest: false };
    }
  };

  const { isShowTest } = getBalanceData();

  function toggleModal(show = true) {
    modalStore.toggleModal("showTestSMSModal", show);
  }

  function handleClick() {
    const hasAttachment = !!values.media || !!values.url;

    if (!values[name] && !(isMms && hasAttachment)) {
      notification.warn("Please Enter a message", 3);
      return;
    }
    if (isMms && hasAttachment && !(values[name] || "").trim()) {
      notification.warn("Please enter any text", 3);
      return;
    }
    if (!values.sender) {
      notification.warn("Please Choose a sender", 3);
      return;
    }
    let media = values.media ? true : false;
    let url = values.url ? true : false;
    if (isMms && !(media ^ url)) {
      notification.warn("Please Add a file", 3);
      modalStore.toggleModal("showAttachFileModal", true);
      return;
    }
    toggleModal(true);
  }

  async function sendGatewayMessage(data, isTest = false) {
    let newData = { ...data };
    const fieldsToRemove = [
      "scheduleAt",
      "activeTab",
      "dayOfMonth",
      "daysOfWeek",
      "endDate",
      "isSchedule",
      "monthWeek",
      "monthWeekDay",
      "monthlyType",
      "repeat",
      "repeatInterval",
      "startDate",
      "sendType",
      "senders",
      "senderType",
      "start_date",
      "end_date",
      "repetitive",
      "status"
    ];

    fieldsToRemove.forEach(field => {
      if (field in newData) delete newData[field];
    });

    newData.contacts = newData.contacts?.filter(x => x) || [];
    newData.message = data[name];
    if (data[name] && values.optout && !data.message.includes(optOutMessageSample)) newData.message = `${data[name]}\n${optOutMessageSample}`;
    if (data[name] && values.replyStopToOptOut && !data.message.includes(replyStopMessageSample)) newData.message = `${data[name]}\n${replyStopMessageSample}`;

    // if (!quickMessage) {
    if (!isEmpty(newData?.groupObj)) {
      newData.groupid = Array.isArray(newData?.groupObj) ? newData?.group?.[0] : newData?.group;
    }
    // }
    if (quickMessage) {
      if (data.contacts && data.contacts.length > 0) {
        if (data.numberList && data.numberList.length > 0) {
          newData.numberList = data.contacts.map(contact => {
            const contactInfo = data.numberList?.find(item => item.number === contact || item.value === contact);
            return {
              label: contact,
              value: contact,
              number: contact,
              contactData: contactInfo?.contactData || {}
            };
          });
        }
      }
    }

    delete newData.groupObj;
    delete newData.group;

    delete newData.selectedGroupIds;

    if (data.numberListTrue) {
      delete newData.groupid;
    } else {
      if (!isTest && quickMessage) {
        const templateObj = values?.numberList?.[0];

        if (templateObj) {
          const newNumberList = data.contacts.map(contact => ({
            ...templateObj,
            label: `${templateObj.contactData?.first_name || templateObj.label.split("-")[0].trim()} - ${contact}`,
            value: contact,
            number: contact
          }));

          // Assign back to newData.numberList
          newData.numberList = newNumberList;
        }
      } else if (!isTest) {
        delete newData.numberList;
      }
    }

    if (isMms) {
      if (!newData.media) delete newData.media;
      if (!newData.url) delete newData.url;
      let formData = new FormData();
      Object.entries(newData).forEach(([key, value]) => {
        if (!["contacts", "numberList"].includes(key)) formData.append(key, value);
      });
      formData.append("contacts", JSON.stringify(newData.contacts));
      if (newData.numberList) {
        formData.append("numberList", JSON.stringify(newData.numberList));
      }
      formData.append("bucket", "general");
      formData.append("category", "group");
      return gatewayMmsStore.addGatewayMMS(formData).then(res => {
        if (res.status) {
          setSuccessAlert(true);
          // setTimeout(() => {
          //   setSuccessAlert(false);
          // }, 3000);
          toggleModal(false);
          isFirstTime && setIsFirstTime(false);
        }
      });
    } else {
      return gatewayStore.addGatewaySMS(newData).then(res => {
        if (res.status) {
          setSuccessAlert(true);
          // setTimeout(() => {
          //   setSuccessAlert(false);
          // }, 3000);
          toggleModal(false);
          isFirstTime && setIsFirstTime(false);
        }
      });
    }
  }
  const shouldShowNextButton = !isFirstTime && !quickMessage && !lowBalanceAlert && showNextButton;

  return (
    <>
      {isShowTest && (
        <AppButton
          light
          withoutBg={quickMessage || !isFirstTime}
          className={clsx({
            "text-decoration-underline text-info-color border-0 bg-light": quickMessage
          })}
          label={label}
          onClick={handleClick}
          size={size}
          {...btnProps}
        />
      )}
      {shouldShowNextButton && <AppButton light label="Next" size={size} onClick={saveAndContinue} />}
      <TestMessage
        isMms={isMms}
        isVisible={modalStore.showTestSMSModal}
        handleCancel={() => toggleModal(false)}
        sendGatewayMessage={sendGatewayMessage}
        skip={skip}
        isFirstTime={isFirstTime}
        values={values}
        name={name}
        saveAndContinue={saveAndContinue}
        setFieldValue={setFieldValue}
        quickMessage={quickMessage}
        lowBalanceAlert={lowBalanceAlert}
        showNextButton={showNextButton}
        initializeValue={formattedContact}
      />
      <AlertModal
        visible={successAlert}
        title="Test Message sent!"
        description="Please check message on your selected number or check in history."
        primaryBtnProps={{ onClick: () => setSuccessAlert(false), label: "Proceed" }}
        secondaryBtnProps={{
          onClick: () => {
            setSuccessAlert(false);
            window.open("/history", "_blank");
          },
          label: (
            <>
              History <i className="fas fa-external-link-alt" style={{ marginLeft: "6px" }}></i>
            </>
          )
        }}
        onCancel={() => setSuccessAlert(false)}
      />
    </>
  );
}

export default inject(stores => ({
  modalStore: stores.store.modalStore,
  gatewayStore: stores.store.gatewayStore,
  gatewayMmsStore: stores.store.gatewayMmsStore,
  testMessageStore: stores.store.testMessageStore,
  authStore: stores.store.authStore
}))(observer(SendTestSMS));
